const NET_ZERO_YEAR = 2050

/** Selectable target years for a reduction plan: base+5 (SBTi near-term minimum) through 2050, so a
 *  target can run to the net-zero year the PPN 006 Carbon Reduction Plan commits to. The 1.5°C
 *  pathway floors at zero once it reaches net zero (~2044), so the long horizon is safe. The
 *  max(...) guard keeps the list non-empty once base years land within five years of 2050. */
export const targetYearOptions = (baseEndYear: number): string[] => {
  const firstTargetYear = baseEndYear + 5
  const lastTargetYear = Math.max(NET_ZERO_YEAR, firstTargetYear)
  return Array.from({ length: lastTargetYear - firstTargetYear + 1 }, (_, i) => (firstTargetYear + i).toString())
}
